import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
   // faMoon,
   faSun,
   faQuoteLeft,
   faChevronLeft,
   faChevronRight,
   faChevronDown,
   faEnvelope,
   faHashtag,
   faArrowRight,
   faArrowLeft,
   faArrowDown,
   faClock,
   faGlobe,
   faTimes,
   faTimesCircle,
   faExclamationCircle,
   faSpinner,
   faCheck,
   faXmark,
   faMagnifyingGlass,
   faPaperclip,
   faThumbsUp,
   faFile,
   faPaperPlane,
} from '@fortawesome/free-solid-svg-icons'

import {
   faFacebookF,
   faXTwitter,
   faRedditAlien,
   faTelegramPlane,
   faLinkedinIn,
   faWeixin,
} from '@fortawesome/free-brands-svg-icons'

import { faEnvelope as faEnvelopeOutlined, faMoon, faLinkSimple } from '@fortawesome/free-regular-svg-icons'

const icons = {
   linkSimple: faLinkSimple,
   moon: faMoon,
   sun: faSun,
   quoteLeft: faQuoteLeft,
   chevronLeft: faChevronLeft,
   chevronRight: faChevronRight,
   chevronDown: faChevronDown,
   facebook: faFacebookF,
   twitter: faXTwitter,
   x: faXTwitter,
   reddit: faRedditAlien,
   telegram: faTelegramPlane,
   linkedin: faLinkedinIn,
   wechat: faWeixin,
   email: faEnvelope,
   emailOutline: faEnvelopeOutlined,
   hashtag: faHashtag,
   arrowRight: faArrowRight,
   arrowLeft: faArrowLeft,
   arrowDown: faArrowDown,
   clock: faClock,
   globe: faGlobe,
   times: faTimes,
   timesCircle: faTimesCircle,
   exclamationCircle: faExclamationCircle,
   spinner: faSpinner,
   check: faCheck,
   close: faXmark,
   search: faMagnifyingGlass,
   attachment: faPaperclip,
   success: faThumbsUp,
   file: faFile,
   paperPlane: faPaperPlane,
}

const FontAwesome = ({ icon, ...rest }) => (
   <FontAwesomeIcon icon={icons[icon] ? icons[icon] : icons.hashtag} {...rest} />
)

export default FontAwesome
